import uuid from "react-native-uuid";

export function generateId(): string {
  const id = uuid.v4();

  if (typeof id !== "string") {
    throw new Error("UUID generation failed");
  }

  return id;
}
